import { render, staticRenderFns } from "./LandingPrivacyPolicy.vue?vue&type=template&id=50399bc7&scoped=true"
import script from "./LandingPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LandingPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./LandingPrivacyPolicy.vue?vue&type=style&index=0&id=50399bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50399bc7",
  null
  
)

export default component.exports